import React, { MouseEventHandler } from 'react';
import ContentLoader from 'react-content-loader';
import { Backdrop, CreateMenuWrapper as CreateMenuWrapperInner, ModalWrapper } from './CreateMenu.style';

interface ISuspendedCreatesMenu {
    isOnTop: boolean;
    handleOpenCloseCreateMenu: MouseEventHandler<HTMLDivElement>;
}

export const SuspendedCreateMenu = ({ isOnTop, handleOpenCloseCreateMenu }: ISuspendedCreatesMenu) => {
    return (
        <>
            <Backdrop isontop={isOnTop} onClick={handleOpenCloseCreateMenu} />
            <ModalWrapper isontop={isOnTop}>
                <CreateMenuWrapperInner style={{ padding: '15px 0 33px 54px' }} showModal={true}>
                    <ContentLoader
                        viewBox="60 30 1155 400"
                        backgroundColor="#f4f4f4"
                        foregroundColor="#d4d3d3"
                        speed={2.1}
                    >
                        <rect rx="3" height="61" width="366" y="111" x="351.5" id="svg_29" />
                        <rect rx="3" height="61" width="366" y="111" x="781.5" id="svg_30" />
                        <rect rx="19" height="38" width="231" y="45" x="637.5" id="svg_28" />
                        <rect rx="3" height="61" width="366" y="189" x="351.5" id="svg_31" />
                        <rect rx="3" height="61" width="366" y="189" x="781.5" id="svg_32" />
                        <rect rx="3" height="61" width="366" y="266" x="351.5" id="svg_33" />
                        <rect rx="3" height="61" width="366" y="266" x="781.5" id="svg_34" />
                        <rect rx="3" height="61" width="366" y="342" x="351.5" id="svg_35" />
                        <path
                            opacity="undefined"
                            d="m781.5,345c0,-1.63014 1.36986,-3 3,-3l360,0c1.63014,0 3,1.36986 3,3l0,55c0,1.63014 -1.36986,3 -3,3l-360,0c-1.63014,0 -3,-1.36986 -3,-3l0,-55z"
                            id="svg_36"
                        />
                        <rect rx="7.5" height="15" width="204" y="56" x="340.5" id="svg_37" />
                        <rect rx="7.5" height="15" width="94" y="115" x="102.5" id="svg_38" />
                        <rect rx="7.5" height="15" width="178" y="168" x="102.5" id="svg_39" />
                        <rect rx="7.5" height="15" width="46" y="221" x="102.5" id="svg_40" />
                        <rect rx="7.5" height="15" width="147" y="276" x="102.5" id="svg_41" />
                        <rect rx="7.5" height="15" width="147" y="330" x="102.5" id="svg_42" />
                        <rect rx="15" height="30" width="30" y="160" x="68.5" id="svg_44" />
                        <rect rx="15" height="30" width="30" y="213" x="68.5" id="svg_45" />
                        <rect rx="15" height="30" width="30" y="268" x="68.5" id="svg_46" />
                        <rect rx="15" height="30" width="30" y="322" x="68.5" id="svg_47" />
                        <rect rx="7.5" height="15" width="22" y="56" x="578.5" id="svg_49" />
                    </ContentLoader>
                </CreateMenuWrapperInner>
            </ModalWrapper>
        </>
    );
};
